/**
 * PDF related apis
 */

import { request } from './request';
import { getBlobRequestConfig } from './config';
import { 
  REQUEST_REPORT_ACTION, 
} from './ajaxActions';
import {
  OK
} from './ajaxActionResponse';
import { parsePdf } from './file/fileUtil';

/**
 * Retrieves PDF as a document for viewing
 * request success reponse from server: {'message' : 'replyPDFMessage', 'id' : $idPDF, 'text': $PDFDoc}
 * @param {integer} id id of PDF to request
 */
export function getReportById(id) {
  // const config = getBlobRequestConfig({id: id}, REQUEST_REPORT_ACTION);
  const config = getBlobRequestConfig({id: id}, REQUEST_REPORT_ACTION, '/file/reports');
  return new Promise((resolve, reject) => {
    request(config)
        .then((response) => {
            if (response.data.status===OK) {
              const report = parsePdf(atob(response.data.data.report));
              resolve({report: report});
            } else {
              reject(response.data.message);
            }
        })
        .catch((err) => {
          reject(err);
        });
  });
}
